<template>
  <div class="service_page page">
    <div class="top_bg">
      <img :src="banner?api+banner:require('../assets/download_bg.png')">
    </div>

    <b-container class="service_content my_content">
      <p class="title">{{ pageData.name }}</p>


      <div style="margin-top: 50px" v-html="pageData.content"></div>

      <!--      <div class="link_item">-->
      <!--        <p class="sub_title">总部</p>-->
      <!--        <p class="info">161 Baypointe Pkwy, San Jose, CA 95134, United States</p>-->
      <!--        <p class="info"> 电话：+1-408-933-1088</p>-->
      <!--      </div>-->

      <!--      <div class="link_item">-->
      <!--        <p class="sub_title">中国</p>-->

      <!--        <p class="info">中国广东省深圳市南山区科发路8号金融基地1栋5层EF</p>-->
      <!--        <p class="info">电话：+86-755-26656230</p>-->
      <!--        <p class="info">商务合作：saleschina@lexar.com</p>-->
      <!--        <p class="info">售后服务：chinasupport@lexar.com</p>-->
      <!--      </div>-->

    </b-container>

  </div>
</template>

<script>

import {singleDetail} from '../api/HomeService'
import {api} from '../api/api';


export default {
  name: "Service",
  data() {
    return {
      languageNum: window.localStorage.getItem("languageNum"),
      pageData: {},
      title: '',
      banner: '',
      api:api
    }
  },
  methods: {
    getTypeList() {
      let sendData = {
        languageNum: this.languageNum,
        type: 2
      }
      singleDetail(sendData, data => {
        this.pageData = data[0] || {};
        // console.log(data)
      })
    }
  },
  mounted() {
    let menuList = JSON.parse(window.localStorage.getItem('menuList'));
    for (let i = 0; i < menuList.length; i++) {
      if (menuList[i].children) {
        for (let j = 0; j < menuList[i].children.length; j++) {
          if (this.$route.path.indexOf(menuList[i].children[j].menuUrl) > 0) {
            this.title = menuList[i].children[j].title
            this.banner = menuList[i].children[j].banner
          }
        }
      }
    }
    this.getTypeList();
  }
}
</script>

<style scoped lang="scss" src="../css/service.scss">

</style>